<template>
<div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
        <i class="lt"></i>
        <i class="rt"></i>
        <el-tab-pane name="jsgl">
            <span slot="label">
                <i class="iconfont iconcheck"></i>
                <i class="border"></i> 告警加权
            </span>
            <div class="w_normalNav">
                <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
                <button class="OrangeSmBtn" @click="reset">重置</button>
                <button class="GreenSmBtn" @click="addnew">新增</button>
            </div>
            <div class="searchForm1">
                <el-form ref="seefrom" class="uLabelDcontent" :model="seefrom">
                    <el-form-item label="关键字名称">
                        <el-input placeholder="请输入关键字" v-model="seefrom.alarmKey"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="tableWrapper" v-loading="!showTable">
                <!-- 后端分页 -->
                <easyTable apiUrl="operation/alarm/findWeighting" :parent="self" :config="config" :other="other" ref="weighting">

                    <template slot="last">
                        <el-table-column prop="level" label="告警等级" :formatter="stateType"></el-table-column>
                    </template>
                    <template slot="last">
                        <el-table-column label="操作" width="300" align="center">
                            <template slot-scope="scope">
                                <el-link icon="iconfont iconedit" type="text" size="small"   @click="edit(scope.$index,  scope.row)"   >编辑</el-link>
                                <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index,scope.row)">删除</el-link>
                                <el-link icon="iconfont iconadd" type="text" size="small"    @click="tridev(scope.$index,scope.row)"   >关联设备</el-link>
                            </template>
                        </el-table-column>
                    </template>
                </easyTable>
            </div>

            <el-dialog class="editDialog" :visible.sync="displayForm" :title="title" :close-on-click-modal="false">
                <el-form ref="addEquipment" :model="addEquipment" :rules="rules">
                  <el-form-item label="关键字" prop="alarmKey">
                    <el-select :popper-append-to-body="false" v-model="addEquipment.alarmKey" placeholder="请选择关键字" style="width:100%">
                      <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="设备类型" prop="deviceType">
                    <el-select :popper-append-to-body="false" v-model="addEquipment.deviceType" value placeholder="请选择设备类型" style="width:100%" >
                      <el-option v-for="item1 in optionType" :key="item1.id" :label="item1.typeName" :value="item1.id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="告警等级" prop="alarmLevel">
                    <el-select :popper-append-to-body="false" v-model="addEquipment.alarmLevel" value placeholder="请选择处理类型" style="width:100%">
                      <el-option v-for="item2 in options3" :key="item2.value" :label="item2.name" :value="item2.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" v-if="seeBtn">
                    <el-button class="cancelButton" @click="displayFalse">取 消</el-button>
                    <el-button class="confirmButton" type="primary" @click="submitAdd">确 定</el-button>
                </div>
            </el-dialog>
          <!-- 关联弹出框 -->
          <el-dialog
            class="editDialog"
            :visible.sync="weightingDisplayForm"
            :title="title"
            :close-on-click-modal="false"
            width="90%">
            <div>
            <div class="searchForm1">
              <el-form ref="seefromDev" class="uLabelDcontent"  :model="seefromDev">
                <el-form-item label="">
                  <el-input placeholder="请输入设备名称" v-model="seefromDev.deviceName"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input placeholder="请输入编码" v-model="seefromDev.imei"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <button class="BlueSmBtn" @click="subSeefromDev">搜索</button>
                  <button class="OrangeSmBtn" @click="resetDev">重置</button>
                  <button class="BlueSmBtn" @click="relevancyDev">关联</button>
                </el-form-item>
              </el-form>
            </div>

            <el-table
              :data="deviceDataList"
              height="600"
              ref="deviceDataListTable"
              style="width: 100%;" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" align="center"/>
              <el-table-column
                prop="deviceName"
                header-align="center"
                align="center"
                min-width="100%"
                label="设备名称">
              </el-table-column>
              <el-table-column
                prop="device_mark"
                header-align="center"
                align="center"
                min-width="110%"
                label="设备编号">
              </el-table-column>

              <el-table-column
                prop="deviceTypeName"
                header-align="center"
                align="center"
                min-width="110%"
                label="设备类型名称">
              </el-table-column>
              <el-table-column
                prop="region"
                header-align="center"
                align="center"
                min-width="110%"
                label="设备点位">
              </el-table-column>
              <el-table-column
                prop="factory"
                header-align="center"
                align="center"
                min-width="110%"
                label="厂家">
              </el-table-column>
              <el-table-column
                prop="model"
                header-align="center"
                align="center"
                min-width="110%"
                label="型号">
              </el-table-column>
            </el-table>
            </div>
          </el-dialog>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import {
    dt,
} from "utils";

export default {
    data() {
        return {
            rules: {
                alarmKey: [{
                    required: true,
                    message: "请输入关键字",
                    trigger: "blur"
                }, ],
                deviceType: [{
                    required: true,
                    message: "请选择设备类型",
                    trigger: "change"
                },],
              alarmLevel: [{
                required: true,
                message: "请选择告警类别",
                trigger: "change"
              },],
            },
            title: "",
            condition1: false,
            condition2: false,
            seeBtn: true,
            tabName: "jsgl",
            loading: true,
            form_jsgl: {},
            editDialogVisible: false,
            displayForm: false,
            showTable: true,
            other: {},
            otherdev:{},
            seefrom: {
              alarmKey: "",
            },
            seefromDev: {
              id:"",
              deviceIds:"",
              deviceName:"",
              imei:"",
              deviceType:"",
            },
            options: [],
            options2: [],
            options3: [],
            optionType: [],
            statusFlag: 0,
            addEquipment: {
              id:"",
              alarmKey: "",
              deviceType: "",
              alarmLevel: "",
            },
            weightingDisplayForm: false,
            deviceDataList:[],
            deviceMarks:[],
        };
    },
    computed: {
        self() {
            return this;
        },
        config() {
            return [{
                    prop: "alarmKey",
                    label: "关键字",
                },
                {
                    prop: "deviceTypeName",
                    label: "设备类型名称",
                },

            ];
        },

        dt() {
            return dt.map(({
                label
            }) => label);
        },
    },
    components: {
        normalNav: () => import("public/normalNav"),
        searchForm: () => import("public/searchForm"),
        easyTable: () => import("public/easyTable"),
    },
    methods: {
        // 多选框选中数据
        handleSelectionChange(selection) {
          //获取所有选中项的imei属性的值
          this.deviceMarks = selection.map(item => item.device_mark)
          console.log(this.deviceMarks)
        },

        //取消后刷新
        displayFalse() {
            this.displayForm = false;
        },
        // 关联设备
        relevancyDev(){
          var ids = '';
          for(let i=0;i<this.deviceMarks.length;i++){
            ids += this.deviceMarks + ',';
          }
          this.$axiospost("operation/alarm/updateWeighting", {
            id: this.seefromDev.id,
            deviceIds: ids,
          }).then((res) => {
            if (res.data.status == "10000") {
              this.subSeefrom();
              this.$message({
                type: "success",
                message: "修改成功!",
              });
              this.weightingDisplayForm = false;
            }
          });
        },
        subSeefromDev(){
          this.$axiosget("operation/device/list", {
            params: {
              deviceType: this.seefromDev.deviceType,
              deviceName: this.seefromDev.deviceName,
              imei: this.seefromDev.imei
            }
          }).then((res) => {
            this.deviceDataList = res.data.data.deviceList;
            for (let i = 0; i < this.deviceDataList.length; i++) {
              let ids = this.seefromDev.deviceIds.split(",");
              for(let j=0;j<ids.length;j++){
                if(this.deviceDataList[i].device_mark == ids[j]){
                  this.$nextTick( ()=> {
                    this.$refs.deviceDataListTable.toggleRowSelection(
                      this.deviceDataList[i],
                      true
                    );
                  });
                }
              }
            }
          });

        },
        tridev(index, row){
          this.weightingDisplayForm = true;
          this.seefromDev.deviceType = row.deviceType;
          this.seefromDev.id = row.id;
          this.seefromDev.deviceIds = row.deviceIds;

          //设备类型
          this.$axiosget("operation/device/list", {
            params: {
              deviceType: row.deviceType
            }
          }).then((res) => {
            this.deviceDataList = res.data.data.deviceList;
            for (let i = 0; i < this.deviceDataList.length; i++) {
              let ids = this.seefromDev.deviceIds.split(",");
              for(let j=0;j<ids.length;j++){
                if(this.deviceDataList[i].device_mark == ids[j]){
                  this.$nextTick( ()=> {
                    this.$refs.deviceDataListTable.toggleRowSelection(
                      this.deviceDataList[i],
                      true
                    );
                  });
                }
              }
            }
          });
        },
        //告警等级
        stateType(row, column) {
            if (row.alarmLevel === 2) {
                return "严重告警";
            } else if (row.alarmLevel === 0) {
                return "屏蔽";
            }else if (row.alarmLevel === 1) {
              return "一般告警";
            }
        },

        //搜索
        subSeefrom() {
            this.other = this.seefrom;
            this.$refs.weighting.pageToOne();
            this.$nextTick(this.$refs.weighting.getData);
        },
        //重置
        reset() {
            this.seefrom = {};
        },
        resetDev(){
          this.seefromDev.imei = "";
          this.seefromDev.deviceName = "";
        },
        //新增
        addnew() {
            this.title = "新增";
            this.statusFlag = 1;
            this.displayForm = true;
            this.addEquipment = {
              id: "",
              alarmKey: "",
              deviceType: "",
              alarmLevel: "",
            }
        },
        //修改
        edit(index, row) {
            this.title = "修改";
            this.displayForm = true;
            this.statusFlag = 2;
            this.addEquipment = {
                id: row.id,
                alarmKey: row.alarmKey,
                deviceType: row.deviceType,
                //alarmLevel: row.alarmLevel,
            };
        },
        //确认
        submitAdd() {
            this.$refs.addEquipment.validate((valid) => {
                if (valid) {

                  if( this.statusFlag == 1 ){  // 添加
                    this.$axiospost("operation/alarm/saveWeighting", {
                        alarmKey: this.addEquipment.alarmKey,
                        deviceType: this.addEquipment.deviceType,
                        alarmLevel: this.addEquipment.alarmLevel
                    }).then((res) => {
                      if (res.data.status == "10000") {
                        this.subSeefrom();
                        this.$message({
                          type: "success",
                          message: "添加成功!",
                        });
                        this.displayForm = false;
                      }
                    });
                  }else if( this.statusFlag == 2 ){  // 修改
                    this.$axiospost("operation/alarm/updateWeighting", {
                        id: this.addEquipment.id,
                        alarmKey: this.addEquipment.alarmKey,
                        deviceType: this.addEquipment.deviceType,
                        alarmLevel: this.addEquipment.alarmLevel
                    }).then((res) => {
                      if (res.data.status == "10000") {
                        this.subSeefrom();
                        this.$message({
                          type: "success",
                          message: "修改成功!",
                        });
                        this.displayForm = false;
                      }
                    });
                  }
                } else {
                    this.$message.error("保存失败，请输入必填项！");
                }
            });

        },
        //删除
        deleteMsg(index, row) {
            this.$confirm("是否删除该挑数据?", "删除操作", {
                cancelButtonText: "取消",
                confirmButtonText: "确定",
                type: "warning",
            }).then(() => {
                this.$axiospost("operation/alarm/delWeighting", {
                  id: row.id,
                }).then((res) => {
                    if (res.data.status == "10000") {
                        this.subSeefrom();
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                    }
                });
            }).catch(()=>{

            })
        },

    },
    created() {
        //设备类型
        this.$axiosget("manager/devicetype/getTypeByCompanyId", {
            params: {
                companyId: localStorage.getItem("companyId"),
            },
        }).then((res) => {
            this.optionType = res.data.data;
        });

        //告警等级
        this.$axiosget("operation/dictionaryType/queryByKey", {
            params: {
                key: 'weightingLevel',
            },
        }).then((res) => {
            if (true) {
                this.options3 = res.data.data.list;
            }
        });
        //获取关键字数据
        this.$axiosget("operation/dictionaryType/queryByKey", {
            params: {
                key: 'weightingKey',
            },
        }).then((response) => {
            if (response.data.status == "10000") {
                this.options = response.data.data.list;
            }
        });
    },
};
</script>

<style lang="less" scoped>
.w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
    z-index: 99;
}
.content {
  .searchForm1{
    .uLabelDcontent{
      width:100%;
      display: flex;
      justify-content: space-between;
    }
    .el-form-item{
      width: auto;
    }
  }
    /deep/.editDialog .el-table,.el-table th,/deep/.editDialog.el-table tr,/deep/.editDialog .el-table__row{
      background: #212740;
      color: #909399;

    }
    /deep/.editDialog .el-table tr:nth-child(even){
      background: #22293D;
    }
    /deep/.editDialog .el-table tr{
      background: #1e2132;
    }
    /deep/ .editDialog .el-table th{
      background: #2E3657;
    }
    /deep/.editDialog .el-table td{
      border-bottom: 0px;
    }
  .el-input__inner:focus {
    border: 1px solid #3587c7;
  }
  // .el-table__body tr.current-row>td {
  //   background: #234366;
  // }
  // .el-table tr{
  //   background: #2d374d;
  // }
  // .el-table th{
  //   background: #2d374d;
  // }
  // .el-table td{
  //   background: #2d374d;
  // }

  // .el-table td{
  //   background: #2d374d;
  // }
  // .el-table th, .el-table tr {
  //     background: #2d374d;
  // }
  .cell {
    color: #F2F8FE;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/alarm/weighting/index.vue